import React from "react"

import { MusterheftExportOverlay } from "./MusterheftExportOverlay"
import { useMusterheftExportOverlayModel } from "./model/useMusterheftExportOverlayModel"
import { useSharedMusterheftExportOverlayModel } from "./model/useSharedMusterheftExportOverlayModel"

export interface MusterheftExportPayload {
  projectID: string
  isShareID?: boolean
}

export interface MusterheftExportOverlayConnectorProps {
  payload: MusterheftExportPayload
}

const OwnedMusterheftExportOverlay = React.memo(
  ({ projectID }: { projectID: string }) => (
    <MusterheftExportOverlay
      {...useMusterheftExportOverlayModel({ projectID })}
    />
  )
)
OwnedMusterheftExportOverlay.displayName = "OwnedMusterheftExportOverlay"

const SharedMusterheftExportOverlay = React.memo(
  ({ projectShareID }: { projectShareID: string }) => (
    <MusterheftExportOverlay
      {...useSharedMusterheftExportOverlayModel({ projectShareID })}
    />
  )
)
SharedMusterheftExportOverlay.displayName = "SharedMusterheftExportOverlay"

/**
 * Branches on `isShareID` so the owned and shared variants each call exactly one
 * data model (no skipped queries). The branch is stable for the lifetime of the
 * overlay — the payload does not change — so the two sub-components never swap,
 * keeping hook order intact.
 */
export const MusterheftExportOverlayConnector = React.memo(
  ({ payload }: MusterheftExportOverlayConnectorProps) =>
    payload.isShareID ? (
      <SharedMusterheftExportOverlay projectShareID={payload.projectID} />
    ) : (
      <OwnedMusterheftExportOverlay projectID={payload.projectID} />
    )
)

declare module "shared/context/overlay/registry" {
  interface OverlayPayloadRegistry {
    MUSTERHEFT_EXPORT_OVERLAY: MusterheftExportPayload
  }
}
